// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609230340/js/" + chunkId + "." + {"44":"a76f106a","225":"6d02bd7f","481":"f7d3f842","486":"b9e435af","770":"4209bc85"}[chunkId] + ".0.16698468843180803.chunk.js";
};